var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;fill:url(#D\xE9grad\xE9_sans_nom_3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3",
    y1: 28,
    x2: 64,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8452a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5ca8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,28H18a2,2,0,0,1,0-4H34a2,2,0,0,1,0,4Zm10-2a2,2,0,1,1-2-2,2,2,0,0,1,2,2ZM24,18a2,2,0,0,1,2-2H46a2,2,0,0,1,0,4H26a2,2,0,0,1-2-2ZM56,44H38a6,6,0,0,0-3.59,1.19L21.76,54.68l-.05,0A6,6,0,0,1,12,50V46a2,2,0,0,0-2-2H8a8,8,0,0,1-8-8V10a2,2,0,0,1,4,0V35a5,5,0,0,0,5,5h2a5,5,0,0,1,5,5v5a2,2,0,0,0,2,2,2,2,0,0,0,1.14-.36h0L31.87,42.1h0A10,10,0,0,1,38,40H55a5,5,0,0,0,5-5V9a5,5,0,0,0-5-5H18a2,2,0,0,1,0-4H56a8,8,0,0,1,8,8V36a8,8,0,0,1-8,8ZM10,4a2,2,0,1,1,2-2,2,2,0,0,1-2,2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.5c0963070b33f8b607447f4b1bfe9664.svg";
export { ForwardRef as ReactComponent };